import { render, staticRenderFns } from "./api_changelog.vue?vue&type=template&id=dcfab70a&"
import script from "./api_changelog.vue?vue&type=script&lang=js&"
export * from "./api_changelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports